<script lang="ts" setup>
defineProps<{
  src: string;
}>();

const nuxtApp = useNuxtApp();
const isHydrating = ref(nuxtApp.isHydrating);
const imageLoaded = useState(`image-loaded`, () => !isHydrating.value);

const handleImageError = (e: Event) => {
  const target = e.target as HTMLImageElement;
  target.src = getPortraitItemImage();
};
</script>

<template>
  <div>
    <Transition
      enter-active-class="transition-opacity absolute top-0 left-0 duration-500"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity absolute top-0 left-0 duration-500"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <div
        v-if="!imageLoaded"
        class="h-[316px] w-full relative rounded-t-lg gradient -z-1"></div>
      <img
        v-else
        class="h-full w-full object-fill rounded-t-lg aspect-square -z-1"
        :src="src"
        @load="imageLoaded = true"
        @error="handleImageError" />
    </Transition>
  </div>
</template>

<style scoped>
.gradient {
  background: radial-gradient(
    90% 96.97% at 50% 50%,
    #43346b 0%,
    #0c0c0c 75.92%
  );
}
</style>
